import React, { useEffect, useState } from 'react'
import { formatDate } from "../../../utils/convertDate";
import { FormatMoney } from "../../../utils/formatMoney";
import InvestmentDetails from './InvestmentDetails';
import ProgressCondition from './ProgressCondition';

const LoanDetailComponents = ({loanDetails, cashbackedLoanInvestmentDetails}) => {

 
  return (
    <div >
          <div>
              <div className="mt-10">
                <div className="mt-2 mb-6 font-semibold text-xl  pb-2">
                    <h3 className=" uppercase letter-spacing font-w-600 text-gray-800 mt-5">
                    Loan details{" "}
                    </h3>
                    <hr />
                </div>
              </div>
            
              <div className="mt-6 grid grid-cols-2 gap-x-6 gap-y-12 sm:grid-cols-4">
              <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Loan Reference
                  </label>
                  <div className="mt-2">
                    <p className=" leading-6 text-gray-800">
                      {loanDetails.loanApplicationReference}
                    </p>
                  </div>
                </div>
              <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Loan Type
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.loanType}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                                <label htmlFor="first-name" className="block leading-6 text-gray-900 uppercase font-semibold">Loan Progress State</label>
                                <div className="mt-2">
                                    <p className="  leading-6 text-gray-800">{loanDetails.loanApplicationProgressState}</p>
                                </div>
                            </div>
                            <div className={`sm:col-span-1 mt-1 ${loanDetails.loanType === "Cashbacked" ? "hidden" : "block"}`}>
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                   Organization Name
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.loanCommunityName}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Loan Amount
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {FormatMoney(loanDetails.amount)}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Loan Tenor
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.loanTenor} {loanDetails.loanType === "Cashbacked" ? "day(s)" : "Month(s)"}
                    </p>
                  </div>
                </div>
              
                            <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Credit report
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                    <ProgressCondition isBereau={true} person={loanDetails}>
                                  {loanDetails.isClean === null ? "N/A" : (loanDetails.isClean === true
                                      ? "Good"
                                      : "Bad")}
                                  </ProgressCondition>
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Interest Rate
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.interestRate === 0
                        ? " "
                        : (loanDetails.interestRate) + '%'}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Management Fee
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.managementFeeAmount === 0
                        ? " "
                        : FormatMoney(loanDetails.managementFeeAmount)}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Monthly Repayament Amount
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {FormatMoney(loanDetails.monthlyRepaymentAmount)}
                    </p>
                  </div>
                </div>
                <div className={`sm:col-span-1 mt-1 ${loanDetails.loanType === "Cashbacked" ? "block" : "hidden"}`}>
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Repayment Mode
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.repaymentMode}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Effective Date
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.loanEffectiveDate === "0001-01-01T00:00:00"
                        ? " "
                        : formatDate(loanDetails.loanEffectiveDate)}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Maturity Date
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.loanMaturityDate === "0001-01-01T00:00:00"
                        ? " "
                        : formatDate(loanDetails.loanMaturityDate)}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    First Repayment Date
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.nextRepaymentDate === "0001-01-01T00:00:00"
                        ? " "
                        : formatDate(loanDetails.nextRepaymentDate)}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Repayment Day
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.repaymentDay === 0
                        ? " "
                        : loanDetails.repaymentDay}
                    </p>
                  </div>
                </div>
                <div className={`sm:col-span-1 mt-1 ${loanDetails.loanType === "Cashbacked" ? "hidden" : "block"}`}>
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Statement Bank
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.statementBankName}
                    </p>
                  </div>
                </div>
                <div className={`sm:col-span-1 mt-1 ${loanDetails.loanType === "Cashbacked" ? "hidden" : "block"}`}>
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Statement Account
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.statementAccountNumber}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Loan Booking Status
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.loanBookingStatus?.toLowerCase() === "notset"
                        ? " "
                        : loanDetails.loanBookingStatus}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Loan Approval Status
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails?.loanApprovalStatus?.toLowerCase() === "notset"
                        ? " "
                        : loanDetails?.loanApprovalStatus}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Approval/Rejection Reason
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails?.adminApprovalOrRejectionReason?.length === 0  ? " " : loanDetails?.adminApprovalOrRejectionReason?.[1] ?? loanDetails?.adminApprovalOrRejectionReason?.[0] ?? " " }
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Approved By
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.loanApprovedBy}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Approval Date
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.loanApprovalDate === "0001-01-01T00:00:00"
                        ? " "
                        : formatDate(loanDetails.loanApprovalDate)}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Branch Code
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.branchCode}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Disbursement Account
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.disbursementAccountNumber}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Loan Account
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.loanAccountNumber}
                    </p>
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Offer Letter URL
                  </label>
                  <div className="mt-2">
                    {loanDetails.offerLetterUrl != null ? (
                      <a
                        href={loanDetails.offerLetterUrl}
                        target="_blank"
                        className="font-medium underline"
                        rel="noreferrer"
                      >
                        {" "}
                        Click to view
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Expiry Date
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails.expiryDate === "0001-01-01T00:00:00" ? "N/A" : formatDate(loanDetails.expiryDate)}
                    </p>
                  </div>
                </div>
               {
                loanDetails.loanType?.toLowerCase() !== "Cashbacked" && (
                  <>
                     <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    staff Id
                  </label>
                  <div className="mt-2">
                    {loanDetails.customerIdurl != null ? (
                      <a
                        href={loanDetails.customerIdurl}
                        target="_blank"
                        className="font-medium underline"
                        rel="noreferrer"
                      >
                        {" "} 
                        Click to view
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Pay Slip
                  </label>
                  <div className="mt-2">
                    {loanDetails.customerPaySlipUrl != null ? (
                      <a
                        href={loanDetails.customerPaySlipUrl}
                        target="_blank"
                        className="font-medium underline"
                        rel="noreferrer"
                      >
                        {" "}
                        Click to view
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="sm:col-span-1 mt-1">
                  <label
                    htmlFor="first-name"
                    className="block leading-6 text-gray-900 uppercase font-semibold"
                  >
                    Selected Insurance Company
                  </label>
                  <div className="mt-2">
                    <p className="  leading-6 text-gray-800">
                      {loanDetails?.insuranceCompany}
                    </p>
                  </div>
                </div>
                  </>
                )
               }
              </div>
          </div>
        {
         loanDetails.loanType?.toLowerCase() == "cashbacked" && cashbackedLoanInvestmentDetails != null &&  <InvestmentDetails loanDetails={loanDetails} cashbackedLoanInvestmentDetails={cashbackedLoanInvestmentDetails} />
        }
    </div>
  )
}

export default LoanDetailComponents
